import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext, useField } from 'formik';
import {
  FormControl,
  Select,
  InputLabel,
  makeStyles,
  FormHelperText,
} from '@material-ui/core';

AirportField.propTypes = {};

const useStyles = makeStyles(() => ({
  formControl: {
    width: '100%',
  },
}));

function AirportField({ label, name, required, data, ...props }) {
  const classes = useStyles();
  const { isSubmitting } = useFormikContext();
  const [field, meta, { setValue }] = useField(name);

  const fieldError = meta.error;
  const showError = !!fieldError; //meta.touched && !!fieldError;

  const selectOptions = useMemo(() => {
    if (data && data.countries) {
      return data.countries.map((country) => {
        return country.cities.map((city) => {
          if (city && city.airports) {
            return city.airports.map(({ code, name }) => {
              return (
                <option key={code} value={code}>
                  {city.name}, {country.code} ({code} - {name})
                </option>
              );
            });
          }
        });
      });
    }
    return null;
  }, [data]);

  if (!selectOptions) {
    return null;
  }

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      required={required}
      error={showError}
    >
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <Select
        native
        label={label}
        inputProps={{
          name,
          id: name,
        }}
        {...field}
        {...props}
      >
        <option aria-label="None" value="" />
        {selectOptions}
      </Select>
      <FormHelperText>{fieldError}</FormHelperText>
    </FormControl>
  );
}

export default AirportField;
